import { jwtDecode } from 'jwt-decode';

const API_URL = import.meta.env.VITE_API_URL;

// 型定義
export interface User {
  lineUserId: string;
  name: string;
}

export interface AuthResponse {
  token: string;
  user: User;
}

// APIクライアント
export const api = {
  // LINE認証
  lineLogin: (config: { clientId: string; redirectUri: string; state: string }) => {
    const lineAuthUrl = `https://access.line.me/oauth2/v2.1/authorize?response_type=code&client_id=${config.clientId}&redirect_uri=${encodeURIComponent(config.redirectUri)}&state=${encodeURIComponent(config.state)}&scope=profile`;
    window.location.href = lineAuthUrl;
  },

  // コールバック処理
  handleCallback: async (code: string, state: string): Promise<AuthResponse> => {
    const response = await fetch(`${API_URL}/auth/line/callback?code=${code}&state=${state}`);
    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.error || '認証に失敗しました');
    }
    return response.json();
  },

  // トークンの検証
  verifyToken: (token: string): User | null => {
    try {
      return jwtDecode<User>(token);
    } catch (error) {
      console.error('トークンの検証に失敗しました:', error);
      return null;
    }
  },

  // 認証済みリクエスト
  authenticatedRequest: async (endpoint: string, options: RequestInit = {}) => {
    const token = localStorage.getItem('token');
    if (!token) {
      throw new Error('認証が必要です');
    }

    const response = await fetch(`${API_URL}${endpoint}`, {
      ...options,
      headers: {
        ...options.headers,
        Authorization: `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.error || 'リクエストに失敗しました');
    }

    return response.json();
  },

  // スタッフ一覧の取得
  getStaff: () => {
    return api.authenticatedRequest('/staff');
  },

  // シフト一覧の取得
  getShifts: () => {
    return api.authenticatedRequest('/shifts');
  },
}; 